<script>
import axios from '@/utils/axios';

export default {
 inject: ['setLoading'],
 data() {
  return {
    title: "Inventory",
    text: "Inventory",
    search: '',
    data: [],
    pagination: {
     current_page: 1,
     per_page: 25,
     last_page: 1,
     total: 0,
     links: []
    },
   };
  },

  computed: {
   text1(){
    return `Vendors (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){
   this.vendors();
  }, 

  methods: {
    
    async vendors(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       search: this.search.trim() || '' 
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/inventory/vendors?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.vendors(page);
    },

   clearFilter(){
    this.search = '';
    this.vendors();
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <div class="mb-2">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#vendor_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.vendorModal.vendor();">
            <i class="ti ti-circle-plus me-2"></i>Add Vendor
          </a>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <h5>Vendors List</h5>
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="vendors()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

    <div class="card-body p-0">
    <div class="custom-datatable-filter table-responsive">
    <table class="table datatable thead-light" v-if="data.length">
     <thead>
        <tr>
        <th>#</th>
        <th>Code</th>
        <th>Name</th>
        <th>Company Name</th>
        <th>Email</th>
        <th>Mobile</th>
        <th>Actions</th>
        </tr>
     </thead>
     <tbody>
        <tr v-for="(row, index) in data" :key="row.id">
        <td>{{ serialNo + index + 1 }}.</td>  
        <td><a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#vendor_detail_modal" @click="$refs.vendorModal.vendor(row)" class="fw-bold text-primary">{{ row.code }}</a></td>
        <td>{{ row.name }}
        </td>
        <td>
        <div v-if="row?.company_name !== null">
         <span class="badge bg-light text-primary border rounded-pill me-1 mb-1">{{ row?.company_name }}</span>
        </div>  
        </td>
        <td>{{ row.email }}</td>
        <td>{{ row.mobile }}</td>
        <td>
        <div class="dropdown">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li>
        <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#vendor_modal" @click="$refs.vendorModal.vendor(row)"><i class="ti ti-edit me-1"></i>Edit</a>
        </li>
        <li>
        <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#vendor_contact_modal" @click="$refs.vendorModal.vendorContact(row.id, row.code)"><i class="ti ti-edit me-1"></i>Add Contact</a>
        </li>
        <li>
        <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#vendor_delete_modal" @click="$refs.vendorModal.vendor(row)"><i class="ti ti-trash me-1"></i>Delete</a>
        </li>
        </ul>
        </div>  

        </td>
        </tr>
      </tbody>
     </table>

    <div v-else class="p-3 text-center text-muted"> No records found. </div>
    </div>

    <!-- Pagination -->
    <nav v-if="pagination.links.length > 3" class="m-3">
      <ul class="pagination pagination-sm">
        <li v-for="(link, index) in pagination.links" :key="index"
          :class="['page-item', { active: link.active, disabled: !link.url }]">
          <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
        </li>
      </ul>
    </nav>
  </div>
 </div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<vendor-modal ref="vendorModal" @updated="vendors"></vendor-modal>

</template>

<style scoped>
    .table-responsive {
        overflow-y: auto;
    }
</style>